<template>
  <ul class="blueText fl">
    <li class="blueTextCon" v-for="(item,index) in blueContent" :key="index" >
      <span class='blueTextCon-i fl' @click.stop="$emit('openIframe',item.url,item.name)">
        <span class="blueTextCon-t">{{item.name}} : &nbsp</span>
        <span :class="['blueTextCon-c',{'contentShow':item.show}]"> {{item.text}}</span>
      </span>
      <span class="blueTextCon-m fl" @click.stop="item.show = !item.show">{{ item.show ? '更多∨' : '收起∧' }}</span>
    </li>
  </ul> 
</template>

<script>
export default {
  name: "moreStorage",
  props: {
    blueContent:Array
  }
}
</script>

<style lang="scss" scoped>
.blueText{
  border-top: 1px dashed #dadada;
  width:100%;
  margin-top:10px;
  padding-top:10px;
}
.blueText li{
  font-size:14px;
  color:#333;
  height:36px;
  line-height:36px;
}
.blueText .blueTextCon-i{
  width:calc(100% - 60px);
  display:flex;
  align-items:baseLine;
}
.blueText .blueTextCon-i .blueTextCon-t{
  font-weight:900;
}
.blueText .blueTextCon-i .blueTextCon-c{
  font-weight:400;
  flex: 1;
}
.blueText .contentShow{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.blueText .blueTextCon-i span{
  cursor:pointer;
}
.blueText .blueTextCon-i:hover{
  color:#0c78cf;
  text-decoration:underline;
  text-underline-position: under;
}
.blueText .blueTextCon-m{
  margin-left:16px;
  color:#0c78cf;
  cursor:pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/flowDetail/moreStorage.vue